<script lang="ts" setup>

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axiosInstance from '@/plugins/axios';

const router = useRouter();
const route = useRoute();
const globalMessage = ref({
    activeFrom: new Date(),
    type: '',
    title: '',
    message: ''
});

const messageTypes = [
    { value: 'Info', icon: 'info', color: '#3498db' },
    { value: 'Warning', icon: 'exclamation-triangle', color: '#f1c40f' }, 
    { value: 'Error', icon: 'times-circle', color: '#e74c3c' },
    { value: 'Success', icon: 'check-circle', color: '#2ecc71' }
];

onMounted(async () => {
    if (route.params.id !== 'new') {
        try {
            const response = await axiosInstance.get(`/admin/getGlobalMessage/${route.params.id}`);
            globalMessage.value = response.data;
        } catch (error) {
            console.error('Error fetching message:', error);
        }
    }
});

const saveGlobalMessage = () => {
    try {
        if (route.params.id === 'new') {
            axiosInstance.post('/admin/addGlobalMessage', globalMessage.value)
                .then((response) => {
                    router.go(-1);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            axiosInstance.put(`/admin/updateGlobalMessage/${route.params.id}`, globalMessage.value)
                .then((response) => {
                    router.go(-1);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    } catch (error) {
        console.log(error);
    }
};

const deleteGlobalMessage = () => {
    try {
        axiosInstance.delete(`/admin/deleteGlobalMessage/${route.params.id}`)
            .then((response) => {
                console.log(response);
                router.go(-1);
            })
            .catch((error) => {
                console.log(error);
            });
    } catch (error) {
        console.log(error);
    }
};

</script>

<template>
    <div>
    <div class="card p-3">

        <form>
            <fieldset>
                <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Active From</label>
                    <DatePicker id="datepicker-24h" v-model="globalMessage.activeFrom" showTime hourFormat="24" fluid />
                </div>
                <div class="mb-3">
                    <label for="disabledTextInput" class="form-label">Active To</label>
                    <DatePicker id="datepicker-24h" v-model="globalMessage.activeTo" showTime hourFormat="24" fluid />
                </div>
                <div class="mb-3">
                    <label for="disabledSelect" class="form-label">Type</label>
                    <SelectButton class="w-full" v-model="globalMessage.type" :options="messageTypes" optionValue="value">
                        <template #option="option">
                            <span :style="{ color: option.option.color }">
                                <font-awesome-icon :icon="['fas', option.option.icon]" />
                            </span>
                        </template>
                    </SelectButton>
                </div>
                <div class="mb-3">
                    <label for="disabledSelect" class="form-label">Title</label>
                    <InputText v-model="globalMessage.title" class="w-full"/>
                </div>
                <div class="mb-3">
                    <label for="disabledSelect" class="form-label">Message</label>
                    <LimitedEditor v-model="globalMessage.message" editorStyle="height: 200px"/>
                </div>
                <div class="flex justify-content-between">
                    <Button @click="deleteGlobalMessage" severity="danger" class="w-50">Delete</Button>
                    <Button @click="saveGlobalMessage" class="p-button-tuev w-50 ml-2">Save</Button>
                </div>
            </fieldset>
        </form>
    </div>
</div>
</template>

<style scoped>

</style>
